<template>
  <div>
    <back></back>
    <div class="title">
      <div>项目名称：{{ projectName }}</div>
      <!-- 按钮 -->
      <el-button type="primary" @click="add()">新增时间段</el-button>
    </div>
    <!-- 表格 -->
    <div class="g_table" style="max-height: 540; overflow: auto">
      <el-table :data="tableData" style="width: 100%" max-height="540">
        <el-table-column label="序号" width="50" show-overflow-tooltip fixed="left">
          <template slot-scope="scope">
            {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
          </template>
        </el-table-column>
        <el-table-column prop="projectName" label="可预约时间段" show-overflow-tooltip min-width="200">
          <template slot-scope="scope">{{ scope.row.startHour }} ~ {{ scope.row.endHour }}</template>
        </el-table-column>
        <el-table-column prop="maxCount" label="最大预约人数" show-overflow-tooltip min-width="140"></el-table-column>
        <el-table-column label="状态" header-align="center" align="center" min-width="100">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.switch" active-color="#" inactive-color="#E2E2E2" @change="changeStatus(scope.row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center" width="210" fixed="right">
          <template slot-scope="scope">
            <el-button size="small" class="btn" type="primary" plain @click="modify(scope.row)">修改</el-button>
            <el-button size="small" class="btn" type="danger" plain @click="handleDele(scope.row)">删除</el-button>
            <!-- <el-button class="btn" type="primary" plain @click="handleOpenPicDialog(scope.row)">编辑</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr" layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"></el-pagination>

    <el-dialog :title="title" :visible.sync="showViewer" width="30%" @close="() => (this.showViewer = false)">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="250px">
        <el-row>
          <el-col :span="11">
            <el-form-item label="可预约时间段：" prop="dataTime">
              <el-time-picker is-range v-model="ruleForm.dataTime" :clearable="false" format="HH:mm" value-format="HH:mm" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围"></el-time-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="最大预约人数：" prop="maxCount">
              <el-input v-model.number="ruleForm.maxCount" placeholder="请输入最大预约人数"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCloseDialog('ruleForm')">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      projectName: "",
      // 表格数据
      tableData: [],
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）
      showViewer: false,
      title: "新增",
      ruleForm: {
        maxCount: "",
        dataTime: ["", ""],
      },
      rules: {
        maxCount: [
          { required: true, message: "请输入数字", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              const regex = /^[0-9]*$/
              if (!regex.test(value)) {
                callback(new Error("只能输入数字"))
              } else {
                callback()
              }
            },
            trigger: "blur",
          },
        ],
        dataTime: [{ required: true, message: "请选择时间段", trigger: "blur" }],
      },
    }
  },
  created() {
    this.projectName = this.$route.query.projectName
    this.getShopProductList()
  },
  methods: {
    add() {
      this.showViewer = true
      this.title = "新增"
    },
    handleCloseDialog(formName) {
      // 重置校验
      this.$refs[formName].resetFields()
      this.showViewer = false
      // this.ruleForm = {}
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (!valid) {
          this.$message.error("提交失败")
          return false
        } else {
          let aipUrl
          if (this.title == "新增") {
            aipUrl = this.$api.insertProject
          } else {
            aipUrl = this.$api.updateProject
          }
          this.$axios
            .post(aipUrl, {
              maxCount: this.ruleForm.maxCount,
              startHour: this.ruleForm.dataTime[0],
              endHour: this.ruleForm.dataTime[1],
              projectId: this.$route.query.projectId,
              storeId: this.$store.state.userInfo.bizId,
              projectName: this.projectName,
              id: this.ruleForm.id,
            })
            .then(res => {
              this.getShopProductList()
              this.$message.success(res.desc)
              this.ruleForm = {}
              this.showViewer = false
            })
            .catch(error => {
              this.$message.error(error.desc)
            })
        }
      })
    },
    // 获取项目列表
    getShopProductList() {
      this.loading = true
      this.$axios
        .post(this.$api.selectProjectConfigList, {
          projectId: this.$route.query.projectId,
          storeId: this.$store.state.userInfo.bizId,
          page: this.currentPage,
          pageSize: this.pageSize,
        })
        .then(res => {
          if (res.code == 100) {
            let list = res.result.list.map(e => {
              return {
                ...e,
                switch: e.mallStatus == 1 ? true : false,
              }
            })
            this.tableData = list
            this.totalItemsCount = res.result.totalCount
          }
          this.loading = false
        })
        .catch(err => {
          this.$message.error(err.desc)
          this.loading = false
        })
    },
    // 修改
    modify(row) {
      this.title = "修改"
      this.showViewer = true
      this.ruleForm = Object.assign({}, row)
      this.$set(this.ruleForm, "dataTime", [row.startHour, row.endHour])
      // this.ruleForm.dataTime = [row.startHour, row.endHour]
    },
    // 删除
    handleDele(row) {
      this.$confirm("确定删除该设置？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(() => {
        this.$axios
          .get(this.$api.deleteProject, {
            params: {
              id: row.id,
            },
          })
          .then(res => {
            this.$message.success(res.desc)
            this.getShopProductList()
          })
          .catch(err => {
            this.$message.warning(err.desc)
          })
      })
    },
    // 切换上下架
    changeStatus(row) {
      const originalSwitch = row.switch
      this.$confirm(`确定${row.switch ? "启动" : "关闭"}该时间段吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$axios
            .post(this.$api.updateProjectStatus, {
              id: row.id,
              mallStatus: row.switch ? 1 : 0,
            })
            .then(() => {
              this.$set(row, "switch", originalSwitch)
              this.$message.success("操作成功")
              this.getShopProductList()
            })
            .catch(() => {
              this.$set(row, "switch", !originalSwitch)
              this.$message.error("操作失败")
              this.getShopProductList()
            })
        })
        .catch(() => {
          this.$set(row, "switch", !originalSwitch)
          this.getShopProductList()
        })
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.clearData()
      this.pageSize = e
      this.getShopProductList()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.getShopProductList()
    },
  },
}
</script>

<style scoped lang="scss">
.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 50px;
}
.demo_ruleForm {
  // .el-row {
  //   width: 100% !important;
  // }
}
</style>
